export default {
  modal: {
    show: false,
    type: ''
  },
  alert: {
    show: false,
    msg: ''
  },
  confirm: {
    show: false
  },
  chance: 0,
  prizeList: {
    list: []
  },
  goToLogin: false,
  showGuide: false,
  userInfo: {
    list: [],
    profile: {}
  },
  userStatus: 0,
  updateStyle: false,
  loading: false
}
